import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import CoinDetail from "@/pages/CoinDetail";
import OnChainCoinDetail from "@/pages/OnChainCoinDetail";

export default function CoinPage() {
  const { id } = useParams();
  const [mode, setMode] = useState("loading");
  const [onchainCoin, setOnchainCoin] = useState(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data } = await api.get(`/coins/onchain/${id}`);
        if (alive) { setOnchainCoin(data); setMode("onchain"); }
      } catch (e) {
        if (alive) setMode("preview");
      }
    })();
    return () => { alive = false; };
  }, [id]);

  if (mode === "loading") return <div className="text-center py-20 text-muted-foreground">Loading…</div>;
  if (mode === "onchain") return <OnChainCoinDetail coin={onchainCoin} />;
  return <CoinDetail />;
}
